
<zbp-icon [iconName]="iconName" class="role-icon" aria-hidden="true" iconSize="font-size"></zbp-icon>
